<script>
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

  import ImageTile from './ImageTile.svelte';
  import ProductInformation from './ProductInformation.svelte';
  import Rating from './Rating.svelte';
  import { onMount, setContext } from 'svelte';
  import { emitMiniActionEvent } from '../tracking/eventEmitter.js';
  import viewTracker from '../tracking/viewTracker.js';
  import scrollTracker from '../tracking/scrollTracker.js';
  import { key as featureWidthAlignmentWithCinemas } from '../context/featureWidthAlignmentWithCinemas.js';
  import { calculateColumnWidthAlignedWithCinemas } from '../utils/columnWidthCalculator.js';
  import RecommendationHeaderTitle from './RecommendationHeaderTitle.svelte';
  import RecommendationHeaderData from './RecommendationHeaderData.svelte';

  /*                */

  let {
    mainVariation,
    recommendations,
    featureIndex,
    featuresState = {},
    cinemaInjectionContainerWidth,
    tracking,
    additionalClickTracking,
    trackingEventMergeId = null
  } = $props();

  const { width: widthAmount, numberOfVisibleCinemaTiles } = calculateColumnWidthAlignedWithCinemas(
    cinemaInjectionContainerWidth
  );
  setContext(featureWidthAlignmentWithCinemas, {
    widthAmount
  });

  const width = `${widthAmount}px`;

  let attributeNames = $state(
    mainVariation && mainVariation.comparisonAttributes
      ? mainVariation.comparisonAttributes.map((attribute) => attribute.label)
      : []
  );

  let tableLastScrollLeft = 0;
  let columnAlreadyTracked = false;
  let observerTracking;
  let verticalScrollAlreadyTracked = false;
  const columnVisibilityState = new Array(recommendations?.length + 1).fill(false);

  const trackVisibilityVerticalScroll = (columnFeatureIds) => {
    const comparisonTableFeatureId = tracking.id;
    const featureIds = [comparisonTableFeatureId, ...columnFeatureIds];
    emitMiniActionEvent(featureIds);
    verticalScrollAlreadyTracked = true;
  };

  const trackVisibilityHorizontalScroll = (direction, columnFeatureIds = []) => {
    const visibleRecos = [mainVariation, ...recommendations].filter((reco) =>
      columnFeatureIds.includes(reco.tracking?.id)
    );
    const recommendationsTracking = visibleRecos.map((reco) => reco.tracking);
    const recommendationsMeta = visibleRecos.map((reco) => reco.meta);
    scrollTracker(
      tracking,
      recommendationsTracking,
      tracking.id,
      direction,
      recommendationsMeta,
      mainVariation.id
    );
  };

  const handleIntersectTracking = (entries) => {
    const visibleEntries = [];
    entries.forEach((entry) => {
      const affectedColumn = entry.target
        .getAttribute('data-tracking-id')
        ?.split('data_tracking_')[1];

      if (columnVisibilityState[affectedColumn]) {
        return observerTracking.unobserve(entry.target);
      }
      if (entry.isIntersecting) {
        visibleEntries.push(entry);
        columnVisibilityState[affectedColumn] = true;
      }
    });

    const columnFeatureIds = visibleEntries.map((entry) => entry.target.dataset.trackingFeatureId);
    if (columnFeatureIds.length !== 0) {
      !verticalScrollAlreadyTracked
        ? trackVisibilityVerticalScroll(columnFeatureIds)
        : trackVisibilityHorizontalScroll('next', columnFeatureIds);
    }
    visibleEntries.forEach((entity) => observerTracking.unobserve(entity.target));
  };

  onMount(() => {
    const recommendationsTracking = recommendations
      .slice(0, numberOfVisibleCinemaTiles)
      .map((reco) => reco.tracking);

    viewTracker(tracking, recommendationsTracking, featureIndex, trackingEventMergeId);

    const comparisonTable = document.querySelector('.reco_comparison__table__container');
    observerTracking = new IntersectionObserver(handleIntersectTracking);
    const columns = comparisonTable.querySelectorAll('[data-tracking-id]');
    columns.forEach((col) => observerTracking.observe(col));

    comparisonTable.addEventListener('scroll', () => {
      let isScrollRight = comparisonTable.scrollLeft > tableLastScrollLeft;
      if (isScrollRight || columnAlreadyTracked) return;
      trackVisibilityHorizontalScroll('previous');
      columnAlreadyTracked = true;
    });
  });
</script>

{#if recommendations && recommendations.length > 0 && attributeNames.length > 0}
  <div class="reco_comparison__table__container">
    <table>
      <thead>
        <tr>
          <th
            class="column oc-headline-50"
            style:min-width={width}
            style:max-width={width}
            aria-label={mainVariation.name}>
            <oc-tag-v1 size="25" variant="info-secondary">Gewählter Artikel</oc-tag-v1>
            <div class="reco_comparison__table__header_title">
              {mainVariation.brandName}<br />{mainVariation.name}
            </div></th>
          {#each recommendations as recommendation}
            <RecommendationHeaderTitle
              {recommendation}
              {tracking}
              {featureIndex}
              {additionalClickTracking}
              {width} />
          {/each}
        </tr>
        <tr>
          <td class="column" style:min-width={width} style:max-width={width}
            ><div class="reco_comparison__table__header_data">
              <ImageTile
                image={mainVariation.image}
                variationId={mainVariation.id}
                deal={mainVariation.deal}
                isVeryPopular={mainVariation.veryPopular}
                {featuresState} />
              <ProductInformation
                variation={mainVariation}
                pricing={mainVariation.formattedPrice}
                minimumOrderValueEligible={mainVariation.minimumOrderValueEligible}
                tableTracking={tracking} />
            </div></td>
          {#each recommendations as recommendation, index}
            <RecommendationHeaderData
              {recommendation}
              {index}
              {tracking}
              {featureIndex}
              {additionalClickTracking}
              {width}
              {featuresState} />
          {/each}
        </tr>
      </thead>
      <tbody>
        {#each attributeNames as attributeName}
          <tr>
            <td class="column oc-copy-100" style:min-width={width} style:max-width={width}>
              <h2 class="attribute-header oc-headline-25">{attributeName}</h2>
              <ul>
                {#each mainVariation.comparisonAttributes.find((attribute) => attribute.label === attributeName)?.values || [] as value}
                  <li>{value}</li>
                {/each}
              </ul>
            </td>
            {#each recommendations as recommendation, index}
              <td
                class="column oc-copy-100"
                style:min-width={width}
                style:max-width={width}
                data-tracking-id={'data_tracking_' + index}
                data-tracking-feature-id={recommendation.tracking?.id}>
                <div
                  class="attribute-header oc-headline-25 attribute-header--ghost"
                  aria-hidden="true">
                  {attributeName}
                </div>
                <ul>
                  {#each recommendation.comparisonAttributes?.find((attribute) => attribute.label === attributeName)?.values || [] as value}
                    <li>{value}</li>
                  {/each}
                </ul></td>
            {/each}
          </tr>
        {/each}
        {#if (mainVariation.numberOfReviews && mainVariation.averageRatingRounded) || recommendations.some((reco) => reco.numberOfReviews && reco.averageRatingRounded)}
          <tr>
            <td class="column oc-copy-100" style:min-width={width} style:max-width={width}>
              <h2 class="attribute-header oc-headline-25">Bewertungen</h2>
              <Rating variation={mainVariation} />
            </td>
            {#each recommendations as recommendation, index}
              <td
                class="column oc-copy-100"
                style:min-width={width}
                style:max-width={width}
                data-tracking-id={'data_tracking_' + index}
                data-tracking-feature-id={recommendation.tracking?.id}>
                <div
                  class="attribute-header oc-headline-25 attribute-header--ghost"
                  aria-hidden="true">
                  Bewertungen
                </div>
                <Rating variation={recommendation} />
              </td>
            {/each}
          </tr>
        {/if}
      </tbody>
    </table>
  </div>
{/if}

<style lang="scss">
  .reco_comparison__table__container {
    overflow-x: auto;
    padding: var(--oc-semantic-spacing-100) var(--oc-semantic-spacing-100) 12px 0;
    margin-left: var(--oc-semantic-spacing-100);
  }

  .reco_comparison__table__header_title {
    line-height: 24px;
    color: #000000;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    word-break: break-word;
  }

  .reco_comparison__table__header_data {
    padding-top: var(--oc-semantic-spacing-100);
    padding-bottom: var(--oc-semantic-spacing-75);
  }

  tr > th:first-child,
  tr > td:first-child {
    position: sticky;
    left: 0;
    background: color-mix(in hsl, var(--oc-semantic-color-hint-25) 61.5%, white 38.5%);
    z-index: 1;
  }

  tbody tr > td {
    position: relative;
    padding: var(--oc-semantic-spacing-75) 0;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-color: #cccccc;
      z-index: 0;
    }

    &:first-child::before {
      content: '';
      position: absolute;
      top: 0;
      left: var(--oc-semantic-spacing-100);
      right: 0;
      height: 1px;
      background-color: #cccccc;
      z-index: 0;
    }

    &:last-child::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: var(--oc-semantic-spacing-100);
      height: 1px;
      background-color: #cccccc;
      z-index: 0;
    }
  }

  .column {
    padding-left: var(--oc-semantic-spacing-100);
    padding-right: var(--oc-semantic-spacing-100);
    vertical-align: top;
  }

  oc-tag-v1 {
    padding-top: var(--oc-semantic-spacing-50);
  }

  ul > li {
    word-break: break-word;
  }

  .attribute-header {
    padding-bottom: var(--oc-semantic-spacing-50);
    word-break: break-word;
  }

  .attribute-header--ghost {
    visibility: hidden;
  }
</style>
